<div class="row g-0 bn-auth__container">
  <div class="col-lg-{{ isExtAuthMode ? '12' : '6' }} bn-auth__side">
    <div class="bn-auth__form">
      <div class="text-center">
        <img
          alt="Bunny.net logo"
          class="bn-auth__logo"
          src="/assets/images/logo-bunnynet-dark-blue.svg" />
        <div class="bn-auth__title">{{ pageText.title }}</div>
        <p class="bn-auth__description mb-2">{{ pageText.description }}</p>
      </div>
      @if (isExtAuthMode) {
        <div class="bn-auth__wp-login__helper-text p-3 my-4 text-center">
          <div class="d-inline-flex flex-row justify-content-center align-items-center mt-1">
            <div class="bn-auth__wp-login__helper-text__connected-logo">
              @if (wpQueries.source === 'wp-plugin') {
                <img
                  alt="WordPress logo"
                  class="bn-auth__wp-login__helper-text__connected-logo--size-wordpress align-middle"
                  src="/assets/libs/auth-pages/images/wordpress-logo.svg" />
              } @else if (wpQueries.source === 'discord') {
                <img
                  alt="Discord logo"
                  class="bn-auth__wp-login__helper-text__connected-logo--size-discord align-middle"
                  src="/assets/libs/auth-pages/images/discord-mark-blue.svg" />
              } @else if (wpQueries.source === 'cli') {
                <fa-icon
                  class="bn-auth__wp-login__helper-text__connected-logo--size-wordpress align-middle"
                  icon="terminal"
                  size="2x" />
              } @else {
                <fa-icon
                  class="bn-auth__wp-login__helper-text__connected-logo--size-wordpress align-middle"
                  icon="question-circle"
                  size="2x" />
              }
            </div>
            <div class="bn-auth__wp-login__helper-text__connecting-line align-middle"></div>
            <div class="bn-auth__wp-login__helper-text__connected-logo align-middle">
              <img
                alt="Bunnynet logo"
                class="bn-auth__wp-login__helper-text__connected-logo--size-bunnynet"
                src="/assets/web-ui/images/logo-bunny-dark.svg" />
            </div>
            <div class="bn-auth__wp-login__helper-text__connecting-icon">
              <fa-icon
                class="mt-6"
                icon="circle-check" />
            </div>
          </div>

          @if (unsafeDomainWarning) {
            <bn-web-ui-alert
              alertType="danger"
              class="text-start text-200-regular mt-4"
              headerIcon="circle-exclamation"
              [heading]="error"
              [showIcon]="true">
              Unrecognized {{ wpQueries.source | uppercase }} return domain<br /><strong>{{ unsafeDomainWarning }}</strong>
            </bn-web-ui-alert>
          } @else {
            <bn-web-ui-alert
              alertType="warning"
              class="text-start text-200-regular mt-4"
              headerIcon="circle-exclamation"
              [showIcon]="true">
              {{ pageText.description2 }}<br /><strong>{{ domainInfo }}</strong>
            </bn-web-ui-alert>
          }
        </div>
        @if (isUserLoggedIn) {
          <div class="bn-auth__wp-login__helper-text p-3 mt-4 mb-2">
            @if (pageText.userEmail) {
              <div>You are logged in as</div>
              <div class="text-300-medium my-4">
                <span class="me-1">
                  <img
                    email="{{ pageText.userEmail }}"
                    ngxGravatar
                    [size]="20" /> </span
                >{{ pageText.userEmail }}
              </div>
            }
            <!-- Alert Not Main Account when trying to login -->
            @if (!isSubUser) {
            } @else {
              @if (isSubUser) {
                <div class="my-3">
                  <bn-web-ui-alert alertType="danger"> You must use your main account for authorization. </bn-web-ui-alert>
                </div>
              }
            }
            <div class="row">
              @if (!isSubUser) {
                <div class="col-6">
                  <button
                    bn-web-ui-button
                    data-e2e="AuthPagesLoginConfirmButton"
                    itemStyle="primary"
                    size="xl"
                    [disabled]="unsafeDomainWarning.length > 0"
                    [fullWidth]="true"
                    (click)="openConfirmationModal()">
                    {{ pageText.login }}
                  </button>
                </div>
              }
              <div [ngClass]="{ 'col-6': !isSubUser, '': isSubUser }">
                <button
                  bn-web-ui-button
                  data-e2e="AuthPagesLoginDifferentAccountButton"
                  itemStyle="stroke"
                  size="xl"
                  [fullWidth]="true"
                  (click)="extAuthChangeUser()">
                  {{ isSubUser ? 'Log In With Different Account' : 'Use Different Account' }}
                </button>
              </div>
            </div>
          </div>
          <div class="text-center">
            <a
              class="btn btn-link"
              data-e2e="AuthPagesLoginCancelLink"
              (click)="extAuthCancel()"
              >Cancel and go home</a
            >
          </div>
        } @else {
          <div class="text-center text-300-medium pb-4">Log In to Your account</div>
        }
      }
      @if (!isUserLoggedIn) {
        <form
          data-e2e="AuthPagesLoginForm"
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit()">
          <div class="mt-3">
            <bn-web-ui-input
              autocomplete="username"
              data-e2e="AuthPagesLoginEmail"
              formControlName="email"
              id="username"
              label="Email"
              placeholder="Email"
              size="md"
              type="email"
              [options]="{ hideRequiredLabel: true }" />
            <div class="mt-3">
              <bn-web-ui-input
                autocomplete="current-password"
                data-e2e="AuthPagesLoginPassword"
                formControlName="password"
                id="password"
                label="Password"
                placeholder="Password"
                size="md"
                type="password"
                [options]="passwordInputSettings" />
            </div>
            <div class="mt-3 row g-0 text-end">
              <div class="col">
                <a
                  class="btn btn-link"
                  data-e2e="AuthPagesLoginForgotPasswordLink"
                  routerLink="../reset-password"
                  >Forgot password?</a
                >
              </div>
            </div>
            <!-- Alert Not Main Account when trying to login -->
            @if (!isExtAuthMode || !isSubUser || !isUserLoggedIn) {
            } @else {
              @if (isSubUser) {
                <div class="my-3">
                  <bn-web-ui-alert alertType="danger"> You must use your main account for authorization. </bn-web-ui-alert>
                </div>
              }
            }
            @if (error) {
              <bn-web-ui-alert
                alertType="danger"
                class="text-start mt-5"
                headerIcon="circle-exclamation"
                [heading]="error"
                [showIcon]="true">
                {{ errorMessage }}
              </bn-web-ui-alert>
            }
            <div class="mt-5">
              <button
                bn-web-ui-button
                data-e2e="AuthPagesLoginSubmitButton"
                size="xl"
                type="submit"
                [disabled]="unsafeDomainWarning.length > 0"
                [fullWidth]="true"
                [loading]="isLoading.submit">
                {{ pageText.login }}
              </button>
            </div>
            <div class="bn-auth__hr">Or continue with</div>
            <div class="bn-auth__providers">
              <a
                class="bn-auth__providers__item"
                data-e2e="AuthPagesLoginGoogleSsoLink"
                [href]="ssoUrlList.google"
                (click)="setLastUsedProvider(SSOService.Google)">
                <img
                  alt="Google logo"
                  src="/assets/images/common/google-logo.svg"
                  title="Login with Google" />
                @if (lastUsedProvider === SSOService.Google) {
                  <span class="bn-auth__providers__last-used">Last used</span>
                }
              </a>
              <a
                class="bn-auth__providers__item bn-auth__providers__item--github"
                data-e2e="AuthPagesLoginGithubSsoLink"
                title="Login with GitHub"
                [href]="ssoUrlList.github"
                (click)="setLastUsedProvider(SSOService.Github)">
                <img
                  alt="GitHub logo"
                  src="/assets/images/common/github-logo.svg"
                  title="Login with GitHub" />
                @if (lastUsedProvider === SSOService.Github) {
                  <span class="bn-auth__providers__last-used">Last used</span>
                }
              </a>
              <a
                class="bn-auth__providers__item"
                data-e2e="AuthPagesLoginGitlabSsoLink"
                [href]="ssoUrlList.gitlab"
                (click)="setLastUsedProvider(SSOService.Gitlab)">
                <img
                  alt="Gitlab logo"
                  src="/assets/images/common/gitlab-logo.svg"
                  title="Login with Gitlab" />
                @if (lastUsedProvider === SSOService.Gitlab) {
                  <span class="bn-auth__providers__last-used">Last used</span>
                }
              </a>
            </div>
            <p class="text-center">
              Don't have an account?
              <a
                class="btn btn-link"
                routerLink="../register"
                [queryParams]="wpQueries"
                >Sign up</a
              >.
            </p>
          </div>
        </form>
      }
    </div>
  </div>
  @if (!isExtAuthMode) {
    <div class="col-lg-6 d-none d-lg-flex bn-auth__side bn-auth__side--right">
      <bn-auth-content-slider
        [centered]="true"
        [items]="sliderConfig"
        [loading]="isLoading.initial" />
    </div>
  }
</div>
